(function () {

    var injectParams = [];

    var Shoveler = function () {

        function Shoveler(obj) {

            var s = this;

            s.title = obj.title;
            s.state = obj.state;
            s.link = obj.link;
            s.phone = obj.phone;
            s.member = (obj.member_filter == true) ? true : false;

        }

        return Shoveler;
    };

    Shoveler.$inject = injectParams;
    angular.module('shoveler-filter').factory('Shoveler', Shoveler);

})();